import PropTypes from 'prop-types'

import icons from './icons'

const Icon = ({ color, width, height, type }) => (
  <svg width={width} height={height} viewBox="0 0 25 25" fill={color}>
    {icons[type]}
  </svg>
)

Icon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  type: PropTypes.string.isRequired
}

Icon.defaultProps = {
  color: '#78BE20',
  width: '60px',
  height: '60px'
}

export default Icon
